<template>
   <div v-if="loading" class="lds-default m-auto absolute left-0 right-0 top-0 bottom-0"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</template>

<script>
    export default {
        name:'loader',
        props:{
            loading:{
                type:Boolean,
                default:false
            }
        },
    }
</script>

